import { DateRangeField, MultiSelect } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import type { TeamMembersFilters } from "./teamMembersFilters";

export interface TeamMembersFilterConfigFormProps {
  stagedFilters: TeamMembersFilters;
  onStagedFiltersChange: (filters: TeamMembersFilters) => void;
  /** Distinct tag values present in the loaded team members. */
  tagOptions: string[];
  /** Distinct role values present in the loaded team members. */
  roleOptions: string[];
}

export const TeamMembersFilterConfigForm = ({
  stagedFilters,
  onStagedFiltersChange,
  tagOptions,
  roleOptions,
}: TeamMembersFilterConfigFormProps) => {
  const { t } = useTranslation("settings");

  return (
    <div className="space-y-2 font-semibold">
      <h3>{t("Filters")}</h3>
      <div className="space-y-4 font-normal">
        <div className="space-y-1.5">
          <span className="text-sm font-medium">{t("Tags")}</span>
          <MultiSelect
            options={tagOptions.map((tag) => ({ label: tag, value: tag }))}
            value={stagedFilters.tags ?? []}
            onValueChange={(tags) =>
              onStagedFiltersChange({ ...stagedFilters, tags: tags.length > 0 ? tags : undefined })
            }
            placeholder={t("Any tag")}
            className="w-64"
          />
        </div>
        <div className="space-y-1.5">
          <span className="text-sm font-medium">{t("Roles")}</span>
          <MultiSelect
            options={roleOptions.map((role) => ({ label: role, value: role }))}
            value={stagedFilters.roles ?? []}
            onValueChange={(roles) =>
              onStagedFiltersChange({ ...stagedFilters, roles: roles.length > 0 ? roles : undefined })
            }
            placeholder={t("Any role")}
            className="w-64"
          />
        </div>
        <div className="space-y-1.5">
          <DateRangeField
            label={t("Last Active")}
            value={stagedFilters.lastActiveRange ?? {}}
            onChange={(value) =>
              onStagedFiltersChange({
                ...stagedFilters,
                lastActiveRange: value.from !== undefined || value.to !== undefined ? value : undefined,
              })
            }
            className="w-64"
          />
        </div>
      </div>
    </div>
  );
};
